import React from 'react';
import { connect } from 'react-redux';
import PageHeader from '../../shared/page-header';

const DownloadClaware = ({ builds }) => {

    const { version = '', link = '' } = builds.length > 0 ? {...builds[builds.length - 1]} : {};

    return (
        <div>
            <PageHeader><span>Claware Downloads</span></PageHeader>
            <div className="row">
                <div className="col-sm-12">
                    <div>
                        {link ?
                            <a href={link}><button type="button" className="btn btn-primary" style={{minWidth: 205}}><i className="fa fa-download"></i>{` Claware ${version} DVD`}</button></a>
                            :
                            <button type="button" className="btn btn-primary" style={{minWidth: 205}} disabled={true}><i className="fa fa-download"></i> Claware DVD</button>
                        }
                        
                        <p className="text-muted" style={{paddingTop: 5, paddingBottom: 10}}>Monday, January 02, 2012 4:18 PM | 1.1 GB</p>
                    </div>
                    <div>
                        <a href={'https://s3.amazonaws.com/fmosoft/Non-English_SP.zip'}><button type="button" className="btn btn-primary" style={{minWidth: 205}}><i className="fa fa-download"></i> Non-English Service Pack</button></a>
                        <p className="text-muted" style={{paddingTop: 5}}>If you are using non-English Windows XP and do not yet have at least service pack 2 installed, you will need this download in addition to the main download above.</p>
                        <p className="text-muted">Monday, January 02, 2012 2:56 PM | 782.9 MB</p>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-sm-12">
                    <h3>Minimum Requirements</h3>
                    <ul>
                        <li>Hard disk: at least 4 GB free space</li>
                        <li>Display: 1024 x 600 or higher resolution</li>
                        <li>Memory: for Windows XP, at least 1 GB; for Windows 7/Vista, at least 2 GB</li>
                        <li>If you are using Mac OS X, you must have an Intel processor with Windows running in a virtual machine that has been alloted at least the minimum memory requirements listed above.</li>
                        <li>Information Technology professionals recommend that you keep at least 20% of your hard drive free no matter what software you use, or your computer may experience a degradation in performance.</li>
                    </ul>
                </div>
            </div>
            <div className="row">
                <div className="col-sm-12">
                    <h2>What's New</h2>
                    <h3>Bug Fixes in 3.83</h3>
                    <ul>
                        <li>In some circumstances, after merging users, it was possible that Export My Completed Data would fail with an error. Fixed</li>
                        <li>On 64-bit versions of Windows, if SQL CE 32-bit was previously installed but SQL CE 64-bit was not, when installing CLAware the 64-bit version of SQL CE would not get installed. This meant CLAware would run fine because it uses 32-bit SQL CE, but launching Literacy Helper would fail because it uses 64-bit SQL CE. Fixed: if 64-bit SQL CE is missing on 64-bit Windows, it now gets installed when installing CLAware.</li>
                    </ul>
                </div>
            </div>
            <div className="row">
                <div className="col-sm-12">
                    <h3>Changes in 3.82</h3>
                    <ul>
                        <li>When you add audio to a Data Record, on the Name Audio form, CLAware defaults the Audio Resolution and the Audio Needs Editing settings to what you selected last time.</li>
                        <li>When you double-click in the Grid View, CLAware opens the item and sets focus on the field based on the column you double-clicked in. For example, if you double-click on a Data Record row in the Notes column, the Data Record will open to the Notes tab.</li>
                        <li>When you right-click on the Practical Expressions event and add a Data Record, the new Data Record will default to a Data Record Type of Practical Expression, and it will default to be filed in the Captured Phrases entry in the Practical Expressions outline.</li>
                    </ul>
                </div>
            </div>
            <div className="row">
                <div className="col-sm-12">
                    <h3>Bug Fixes in 3.82</h3>
                    <ul>
                        <li>Installing on computers with a 64-bit version of Windows, that already had the Charis SIL font caused that font to get corrupted, which led to several errors, including when trying to display data records. Fixed.</li>
                        <li>In some circumstances, importing would give an error and fail. Fixed.</li>
                        <li>If your partner exported an Event to you implicitly (it was only included because it contains a Data Record marked Completed), if you import it and delete the Event, then your partner exports that Event implicitly to you again and you import it: the Event does not appear in the Events tab or the Outlines tab, and double-clicking on the Data Record in the Outlines tab raises an error. Fixed.</li>
                        <li>In some cases, missing pictures in imported data records could cause errors, even preventing the text of the data record from being displayed. Fixed.</li>
                        <li>Made the tooltips for the word processor toolbar disappear within 1/2 second of leaving the toolbar, instead of the tooltips remaining for up to 5 seconds after you moved the mouse off the toolbar.</li>
                        <li>When you moved the speed slider in the Data Record audio control, the speed percentage text disappeared. Fixed.</li>
                        <li>After you change your password and click OK on the Change Password screen, you were taken back to the Add or Change a CLAware User screen, but the password box still had your old password in it, so if you clicked Save, it told you your password was wrong. Very confusing. Fixed: now, after you change your password, the new password is placed in the password box.</li>
                        <li>After creating and saving a new Event or Data Record, you could no longer access the Questions and Roadblocks form: when you clicked the Questions and Roadblocks button you got a message saying there were unsaved changes. You had to exit and re-start CLAware in order to for the Questions and Roadblocks button to work again. Fixed.</li>
                        <li>Includes IPA keyboard 3.6, in which the tone marks produced by AltGr-t + num 1-7 now work.</li>
                    </ul>
                </div>
            </div>
            <div className="row">
                <div className="col-sm-12">
                    <a href="https://s3.amazonaws.com/fmosoft/claware-changelog.txt">View Complete Change Log</a>
                </div>
            </div>
        </div>
    );
};
DownloadClaware.propTypes = {
    builds: React.PropTypes.arrayOf(React.PropTypes.object)
};

const DownloadClawareContainer = connect(
    ({ appState }) => {
        return {
            builds: appState.builds
        };
    }
)(DownloadClaware);

export default DownloadClawareContainer;



// WEBPACK FOOTER //
// ./src/components/download/claware/download-claware.js